import { graphql } from '@/generated/gql';

export const UPSERT_ABSENCE_MUTATION = graphql(/* GraphQL */ `
  mutation UpsertAbsence($userId: UUID, $data: AstroAbsenceInput!) {
    astronaut {
      user(id: $userId) {
        absence {
          upsert(data: $data) {
            id
            start
            end
          }
        }
      }
    }
  }
`);
